// Firebase configuration for Handed Down.
//
// EMPTY BY DESIGN. Every module that touches Firebase checks isConfigured()
// first and returns immediately, so an unconfigured app loads no third-party
// script, makes no request, and shows no sign-in UI. Filling this in is what
// turns the feature on.
//
// These values are public by design — they identify your project, they do not
// authorise anything. Access is controlled by your security rules.

export const firebaseConfig = {
  apiKey: 'AIzaSyBzn-Y55A89a-aVCjq1apGoAKSyeHlq76Y',
  authDomain: 'gen-lang-client-0029897959.firebaseapp.com',
  projectId: 'gen-lang-client-0029897959',
  storageBucket: 'gen-lang-client-0029897959.firebasestorage.app',
  messagingSenderId: '789606350417',
  appId: '1:789606350417:web:71c4ef3ae9834202764270',
  databaseURL: '',
};

// OAuth client id for Google sign-in. Separate from the config above because a
// project can be fully configured for sync while sign-in stays off.
export const googleClientId = '';

export const isConfigured = () => !!(firebaseConfig.apiKey && firebaseConfig.projectId);
export const signInAvailable = () => isConfigured() && !!googleClientId;
